import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api";
import { TASK_STATUSES, TASK_STATUS_LABEL, PRIORITY_LABEL, PRIORITY_CLASS } from "../projectMeta";

export default function SchedulePage() {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function load(status = "") {
    setError("");
    try {
      setRows(await api.get(`/tasks${status ? `?status=${status}` : ""}`));
    } catch (err) { setError(err.message); }
  }
  useEffect(() => { load(); }, []);

  function onFilter(s) {
    setFilter(s);
    load(s);
  }

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Link to="/sstoa" className="sstoa-back">← 홈</Link>
      </div>
      <div className="sstoa-topbar">
        <div>
          <h1 className="sstoa-title">전체 일정</h1>
          <p className="sstoa-sub">모든 프로젝트의 일정을 마감 임박순으로 봅니다.</p>
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <button className={`sstoa-btn sstoa-btn--sm${filter === "" ? " sstoa-btn--primary" : ""}`} onClick={() => onFilter("")}>전체</button>
        {TASK_STATUSES.map(([v, l]) => (
          <button key={v} className={`sstoa-btn sstoa-btn--sm${filter === v ? " sstoa-btn--primary" : ""}`} onClick={() => onFilter(v)}>{l}</button>
        ))}
      </div>

      {error && <div className="sstoa-error">{error}</div>}

      <div className="sstoa-panel">
        {rows === null ? (
          <div className="sstoa-empty">불러오는 중…</div>
        ) : rows.length === 0 ? (
          <div className="sstoa-empty">일정이 없습니다. 프로젝트 상세에서 일정을 추가하세요.</div>
        ) : (
          <table className="sstoa-table">
            <thead><tr><th>상태</th><th>제목</th><th>프로젝트</th><th>마감일</th><th>우선순위</th></tr></thead>
            <tbody>
              {rows.map((t) => {
                const overdue = t.due_date && t.due_date < today && t.status !== "DONE";
                return (
                  <tr key={t.id} onClick={() => t.project && navigate(`/sstoa/projects/${t.project.id}`)}>
                    <td><span className={`sstoa-tag ${t.status === "DONE" ? "sstoa-tag--gray" : ""}`}>{TASK_STATUS_LABEL[t.status] || t.status}</span></td>
                    <td style={{ fontWeight: 600 }}>{t.title}</td>
                    <td>{t.project ? t.project.name : "—"}</td>
                    <td style={{ color: overdue ? "var(--s-danger)" : "inherit", fontWeight: overdue ? 600 : 400 }}>
                      {t.due_date || "—"}{overdue ? " (지남)" : ""}
                    </td>
                    <td><span className={`sstoa-tag ${PRIORITY_CLASS[t.priority] || ""}`}>{PRIORITY_LABEL[t.priority] || t.priority}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
